import { Modal, ModalDialog, DialogContent, DialogTitle, FormControl, FormLabel, Input, Grid, Drawer, ModalClose, Divider, Checkbox, DialogActions, Button, Box } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { eventNames } from "process";

interface ContactsDialogProps {
	contactsId: string;
	close: Function;
	buildingsId: string;
}

interface ContactRecord {
	buildings_id: string;
	contacts_id: string;
	date_entered: string;
	email: string;
	first_name: string;
	is_primary: boolean;
	last_name: string;
	phone_number: string;
	send_arrival_texts: boolean;
	send_callback_texts: boolean;
	send_maint_texts: boolean;
	send_nuisance_texts: boolean;
	send_repair_texts: boolean;
	send_sale_texts: boolean;
	send_violation_texts: boolean;
}
export default function ContactsDialog(props: ContactsDialogProps) {
	const [contact, setContact] = React.useState<ContactRecord>();
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		if (!Util.isNullOrEmpty(props.contactsId)) {
			fetch("Building/GetContact", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(props.contactsId),
			})
				.then((x) => x.json())
				.then((x) => {
					setContact(x as ContactRecord);
					setOpen(true);
				});
		} else {
			setContact({} as ContactRecord);
			setOpen(true);
		}
	}, []);

	const save = () => {
		if (!contact) return;

		contact.buildings_id = props.buildingsId;
		fetch("Building/SaveContact", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ contactData: contact }),
		}).then((x) => close());
	};

	const close = () => {
		props.close();
	};

	const sizes = {
		sm: 12,
		md: 6,
	};

	const threeSizes = {
		sm: 12,
		md: 6,
		lg: 4,
	};
	return (
		<>
			<Drawer anchor="right" open={open} size="lg">
				<ModalClose onClick={close} />
				<DialogTitle>Contact Form</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					{contact && (
						<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
							<Grid xs={12}>
								<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Contact Information</FormLabel>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>First Name</FormLabel>
									<Input
										onChange={(event) => {
											setContact({ ...contact, first_name: event.target.value });
										}}
										value={contact.first_name}
										name="first_name"></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Last Name</FormLabel>
									<Input
										onChange={(event) => {
											setContact({ ...contact, last_name: event.target.value });
										}}
										value={contact.last_name}
										name="last_name"></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Email</FormLabel>
									<Input
										onChange={(event) => {
											setContact({ ...contact, email: event.target.value });
										}}
										value={contact.email}
										name="email_address"></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Phone Number</FormLabel>
									<Input
										onChange={(event) => {
											setContact({ ...contact, phone_number: event.target.value });
										}}
										value={contact.phone_number}
										name=""></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Is Primary?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, is_primary: event.target.checked });
										}}
										checked={contact.is_primary}
									/>
								</FormControl>
							</Grid>
							<Grid xs={12}>
								<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Notification Settings</FormLabel>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Maintenance Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_maint_texts: event.target.checked });
										}}
										checked={contact.send_maint_texts}
									/>
								</FormControl>
							</Grid>
							<Divider sx={{ mt: "auto" }} />
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Sale Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_sale_texts: event.target.checked });
										}}
										checked={contact.send_sale_texts}
									/>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Repair Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_repair_texts: event.target.checked });
										}}
										checked={contact.send_repair_texts}
									/>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Callback Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_callback_texts: event.target.checked });
										}}
										checked={contact.send_callback_texts}
									/>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Violation Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_violation_texts: event.target.checked });
										}}
										checked={contact.send_violation_texts}
									/>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Nuisance Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_nuisance_texts: event.target.checked });
										}}
										checked={contact.send_nuisance_texts}
									/>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Send Arrival Texts?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setContact({ ...contact, send_arrival_texts: event.target.checked });
										}}
										checked={contact.send_arrival_texts}
									/>
								</FormControl>
							</Grid>
						</Grid>
					)}
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
						<Button size="lg" color="primary" onClick={close} sx={{ mx: 1 }}>
							Close
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
